module.exports = __webpack_public_path__ + "img/cert-bg-1x.3a4c5856.png";